import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PlusIcon } from '@icons';
import classNames from 'classnames';
import { nanoid } from 'nanoid';
import { Fragment, useMemo, useRef } from 'react';
import { isDark } from '../common/utils';
import styles from './kbd.module.scss';
const KbdCombination = ({ children, size = 'sm', }) => {
    const items = useRef(children
        ? children.map(child => ({
            child,
            id: nanoid(),
        }))
        : []);
    const combLen = useRef(items.current.length);
    const isDarkMode = useMemo(() => isDark(), []);
    const combinationClass = useMemo(() => classNames(styles.combination, {
        [styles[`combination_${size}`]]: true,
    }), []);
    return (_jsx("div", { className: combinationClass, children: items.current.map((item, index) => (_jsxs(Fragment, { children: [item.child, index >= 0 && index < combLen.current - 1 && (_jsx("span", { className: classNames(styles.plus, isDarkMode ? styles.dark : ''), children: _jsx(PlusIcon, {}) }))] }, item.id))) }));
};
KbdCombination.displayName = 'KbdCombination';
export { KbdCombination };
